export default __webpack_public_path__ + "static/media/stainless-steel-flange.e46de019.webp";